import { types } from 'mobx-state-tree'
import { Layerable } from './shared/props'
import { Rectangle } from './shared/props'
import { Transformable } from './shared/props'
import { Visible } from './shared/props'
import { UI } from './shared/props'
import assetViews from './shared/views'

const AssetType = 'CheckboxGroup'

export default types
  .model(AssetType, {
    Type: types.literal(AssetType),
    objectId: types.identifier,
    name: types.string,
    labeledBy: types.string,
    children: types.late(() => types.array(require('./CheckboxGroupItem').default)),
    ...Rectangle,
    ...Layerable,
    ...Visible,
    ...Transformable,
    ...UI,
  })
  .views(assetViews)
